import { render, staticRenderFns } from "./translate-cmp.vue?vue&type=template&id=5ed8f106&"
import script from "./translate-cmp.vue?vue&type=script&lang=ts&"
export * from "./translate-cmp.vue?vue&type=script&lang=ts&"
import style0 from "./translate-cmp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports